import type { Locale } from "@/lib/i18n";
import { pl, type WShopNewProductsTranslations } from "./pl";
import { en } from "./en";
import { de } from "./de";

export const wShopNewProductsTranslations: Record<
  Locale,
  WShopNewProductsTranslations
> = {
  pl,
  en,
  de,
};

export type { WShopNewProductsTranslations };
